import sliderArrow from '../../../images/slider-arrow.png';

export default theme => ({
    testimonialSlider: {
        position: 'relative',
        marginBottom: 36,
        '& .testimonial': {
            marginBottom: '0 !important',
            '&::before': {
                display: 'none',
            },
        },
        '& .slick-slider': {
            maxWidth: 860,
            margin: '0 auto',
            [theme.breakpoints.up('md')]: {
                maxWidth: 'calc(100% - 250px)'
            },
            '&::before': {
                position: 'absolute',
                border: '3px solid',
                borderRight: 'none',
                borderColor: theme.palette.primary.main,
                content: '""',
                display: 'block',
                width: 40,
                top: 0,
                left: 0,
                bottom: 0,
            }
        },
        '& .slick-dots': {
            fontSize: 0,
            [theme.breakpoints.up('md')]: {
                left: -75,
                top: '50%',
                transform: 'translateY(-50%)',
                width: 20,
                bottom: 'auto',
            },
            '& li': {
                width: 12,
                height: 12,
                margin: '0 12px',
                [theme.breakpoints.up('md')]: {
                    width: 20,
                    height: 20,
                    margin: 10,
                },
                '& button': {
                    width: 12,
                    height: 12,
                    backgroundColor: theme.palette.common.white,
                    borderRadius: '50%',
                    '&::before': {
                        content: '""',
                    },
                    [theme.breakpoints.up('md')]: {
                        width: 20,
                        height: 20,
                    }
                },
                '&.slick-active': {
                    position: 'relative',
                    '& button': {
                        backgroundColor: theme.palette.primary.main,
                        '&::before': {
                            border: '2px solid',
                            borderColor: theme.palette.primary.main,
                            borderRadius: '50%',
                            top: -3,
                            left: -3,
                            width: 18,
                            height: 18,
                            backgroundColor: 'transparent',
                            position: 'absolute',
                            [theme.breakpoints.up('md')]: {
                                top: -5,
                                left: -5,
                                width: 30,
                                height: 30,
                            }
                        }
                    }
                }
            }
        },
        '& .slick-next': {
            width: 18,
            height: 18,
            backgroundImage: 'url(' + sliderArrow + ') !important',
            backgroundSize: 'contain !important',
            backgroundPosition: 'center !important',
            backgroundRepeat: 'no-repeat !important',
            top: 'auto',
            right: 25,
            bottom: -25,
            transform: 'none',
            zIndex: 10,
            '&::before': {
                display: 'none',
            },
            '&.slick-disabled': {
                opacity: 0.25,
            },
            [theme.breakpoints.up('md')]: {
                bottom: 25,
                left: -65,
                transform: 'rotate(90deg)',
            },
        },
        '& .slick-prev': {
            width: 18,
            height: 18,
            backgroundImage: 'url(' + sliderArrow + ') !important',
            backgroundSize: 'contain !important',
            backgroundPosition: 'center !important',
            backgroundRepeat: 'no-repeat !important',
            top: 'auto',
            left: 25,
            bottom: -25,
            transform: 'rotate(180deg)',
            zIndex: 10,
            '&::before': {
                display: 'none',
            },
            '&.slick-disabled': {
                opacity: 0.25,
            },
            [theme.breakpoints.up('md')]: {
                bottom: 'auto',
                top: 25,
                left: -65,
                transform: 'rotate(-90deg)',
            },
        }
    },
    testimonialSliderTheme: {
        ...theme.testimonialSliderTheme,
    }
})